<template>
  <!--  合同审核详情-->
  <div class="advanced-form">

    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>门店信息</h3>
        </div>
        <div class="card-body">
          <a-row
            type="flex"
            justify="space-between"
            style="margin-bottom: 50px"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">门店名称:</div>
              <div>{{data.shopName}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">主营类目:</div>
              <div>{{data.categoryName}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">入驻类型:</div>
              <div>{{data.applyTypeDesc}}</div>
            </div>
          </a-row>
          <a-row
            type="flex"
            justify="space-between"
            style="margin-bottom: 50px"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">店铺类型:</div>
              <div>{{data.shopTypeDesc}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">所在地区:</div>
              <div>{{data.area}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">详细地址:</div>
              <div>{{data.address}}</div>
            </div>

          </a-row>
          <a-row
            type="flex"
            style="margin-bottom: 50px"
            justify="space-between"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">所属商圈:</div>
              <div>{{data.bizAreaName}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">营业电话:</div>
              <div>{{data.telephone}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">门头照片:</div>
              <div>
                <template v-for=" (item,i) in data.shopImage" >
                  <div class="img-box" :key = 'i'>
                    <span >
                      <img :src="item.fileUrl" alt="" @click="openImg(item.fileUrl)" />
                    </span>
                  </div>
                </template>
              </div>

            </div>
          </a-row>
          <a-row
            type="flex"
            style="margin-bottom: 50px"
            justify="space-between"
          >
           <div class="card-box">
              <div style="margin-bottom: 10px">门店位置:</div>
              <div class="amap-box" id="container"  @click="showMap"></div>
            </div>

          </a-row>
        </div>
      </div>
    </a-form>
    <a-modal
      title="查看"
      :visible="visible"
      @cancel="visible = false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="800"
    >
      <div class="model-img"><img :src="img" alt="" /></div>
    </a-modal>

    <div class="card">
      <div class="card-head">
        <h3>基本资质</h3>
      </div>
      <div class="card-body">
        <!--删除列表时使用的是rowKey的id-->
        <a-row type="flex" justify="space-between" style="margin-bottom: 50px">
          <div class="card-box">
            <div style="margin-bottom: 10px">注册号:</div>
            <div>{{data.registerNo}}</div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">执照名称:</div>
            <div>{{data.companyName}}</div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">法人名字:</div>
            <div>{{data.legalPerson}}</div>
          </div>
        </a-row>

        <a-row type="flex" justify="space-between" style="margin-bottom: 50px">
          <div class="card-box">
            <div style="margin-bottom: 10px">法人手机号码:</div>
            <div>{{data.mobile}}</div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">身份证号:</div>
            <div>{{data.idcardNumber}}</div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">证件名字:</div>
            <div>{{data.name}}</div>
          </div>
        </a-row>
        <a-row type="flex" style="margin-bottom: 50px">
          <div class="card-box">
            <div style="margin-bottom: 10px">合同照片:</div>
            <div>
              <template v-for=" (item,i) in data.contractImage" >
                <div class="img-box" :key = 'i'>
                  <span >
                    <img :src="item.fileUrl" alt="" @click="openImg(item.fileUrl)" />
                  </span>
                </div>
              </template>
            </div>
          </div>
        </a-row>
      </div>
    </div>
    <div v-hasPermi="['community:localContractVerify:edit']">
      <approval-model :id = 'id' @pass = "pass" @reject = "reject" v-if="showBanner" ></approval-model>
    </div>
    <map-model ref='mapModel'></map-model>
  </div>
</template>

<script>
import ApprovalModel from '../qualification/approvalModel.vue';
import { empty } from 'ant-design-vue-admin-x';
import mapModel from '../component/mapModel.vue';
export default {
  components: {ApprovalModel, mapModel},
  data () {
    return {
      showBanner: false,
      id: undefined,
      img: undefined,
      position: '',
      visible: false,
      tableData: [],
      data: []
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-nav')[0].style['z-index'] = '161';
      document.getElementsByClassName('layout-aside')[0].style['z-index'] = '200';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor =
        'transparent';
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.backgroundColor =
      '#fff';
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    next();
  },
  created () {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
      this.id = this.$route.query.id;
    }
    if (this.$route.query.status == 2) {
      this.showBanner = true;
    } else {
      this.showBanner = false;
    }
  },
  methods: {
    showMap () {
      this.$refs.mapModel.show(this.data.mapLng, this.data.mapLat);
    },
    pass (val) {
      this.toExamine(4, val);
    },
    reject (val) {
      this.toExamine(3, val);
    },
    toExamine (type, modalValue) {
      //  3:已驳回 4:已生效
      this.$put({
        url: '/local/contractVerify/' + this.id,
        params: {
          status: type, //  3:已驳回 4:已生效
          reason: modalValue // 审核备注
        }
      }).then((res) => {
        this.$message[type == 4 ? 'success' : 'error'](type == 4 ? '审核通过' : '审核已驳回');
        empty.$emit('update_contractReview');
        this.$router.go(-1);
      });
    },
    show () {},
    openImg (img) {
      this.img = img || '';
      this.visible = true;
    },
    getDetail (id) {
      this.$get({
        url: '/local/contractVerify/' + id,
        params: {}
      }).then(({data}) => {
        this.data = data;
        this.initAMap();
      });
    },
    initAMap () {
      this.$nextTick(() => {
        AMapUI.loadUI(['misc/PositionPicker'], (PositionPicker) => {
          this.map = new AMap.Map('container', {
            resizeEnable: true,
            scrollWheel: true
          });
          this.map.setZoomAndCenter(15, [this.data.mapLng, this.data.mapLat]);

          let marker = new AMap.Marker({
            position: new AMap.LngLat(this.data.mapLng, this.data.mapLat),
            anchor: 'bottom-center',
            offset: new AMap.Pixel(0, 0)
          });
          this.map.add(marker);
        });
      });
    }
  }
};
</script>

<style scoped>
.amap-box {
  width: 220px;
  height: 100px;
}
.img-box {
  height: 100px;
  display: inline-block;
  margin: 0 10px 10px 0;
}
.img-box img {
  width: 100px;
  height: 100%;
  object-fit: contain;
  background: #ededed;
}
.model-img img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 800px;
  padding: 5px;
  margin:0 auto;
  display: block;
}
.card-box{
  font-size: 14px;
  width: 33.33333333%;
  word-break: break-all;
}
.card-box>div:nth-child(2){padding-left:8px;margin-top:18px;}
</style>
